import { RdfMemorySource } from "../rdf-memory-source.js";
import { fetchRdfQuads } from "./http-adapter.js";
export class RdfHttpSource extends RdfMemorySource {
    async fetch(httpFetch, url, asMimeType) {
        this.quads.push(...RdfMemorySource.prefixBlankNodes(await fetchRdfQuads(httpFetch, url, asMimeType), url));
    }
}
//# sourceMappingURL=http-rdf-source.js.map